import { getAppMarketMode } from 'utils/session';
import { AppMode } from '../models/enums';

export const useAppMode = () : AppMode => {
    return getAppMarketMode();
};
